import { createSelector } from 'reselect';

export const businessRulesSelector = (state) => state.get('businessRules');

export const loadingSelector = createSelector(
  businessRulesSelector,
  (businessProviderState) => businessProviderState.get('loading')
);

export const errorSelector = createSelector(
  businessRulesSelector,
  (businessProviderState) => businessProviderState.get('error')
);

export const loadedLanguageSelector = createSelector(
  businessRulesSelector,
  (substate) => substate.get('loaded').toJS()
);

export const optionsSelector = createSelector(
  businessRulesSelector,
  (businessProviderState) => businessProviderState.get('options')
);

export const planSelector = createSelector(
  businessRulesSelector,
  (businessProviderState) => businessProviderState.get('plan')
);

export const planLoadingSelector = createSelector(
  businessRulesSelector,
  (businessRulesState) => businessRulesState.get('planLoading')
);

export const planNameSelector = createSelector(
  businessRulesSelector,
  (businessRulesState) => businessRulesState.get('planName')
);

export const planCodeSelector = createSelector(
  businessRulesSelector,
  (businessRulesState) => businessRulesState.get('planCode')
);

export const previousPlanSelector = createSelector(
  businessRulesSelector,
  (businessRulesState) => businessRulesState.getIn(['previous', 'plan'])
);

export const lastActionUpdatedPlanSelector = createSelector(
  planSelector,
  (plan) => plan.get('lastActionUpdatedPlan')
);

export const kitchenIslandSameAsWorktopSelector = createSelector(
  planSelector,
  (plan) => plan.get('kitchenIslandSameAsWorktop')
);

export const wallPanelMatchWorktopSelector = createSelector(
  planSelector,
  (plan) => plan.get('wallPanelMatchWorktop')
);

export const configurationSelector = createSelector(
  optionsSelector,
  (options) => options.get('configuration'),
);

export const twoDigitGroupingForNumbersSelector = createSelector(
  configurationSelector,
  (configuration) => configuration.get('useTwoDigitGroupingForNumbers'),
);

export const useImperialUnitMeasurementsSelector = createSelector(
  configurationSelector,
  (configuration) => configuration.get('useImperialUnitMeasurementsInTheUI'),
);

export const noWallpanelsAvailableSelector = createSelector(
  configurationSelector,
  (configuration) => configuration.get('noWallPanelMaterials'),
);

export const useFamilyPriceSelector = createSelector(
  configurationSelector,
  (configuration) => configuration.get('useFamilyPrice'),
);


export const useDualFamilyPriceSelector = createSelector(
  configurationSelector,
  (configuration) => configuration.get('useDualFamilyPrice'),
);

export const customerSignatureSelector = createSelector(
  configurationSelector,
  (configuration) => configuration.get('useCustomerSignature'),
);

export const useCoverPanelsSelector = createSelector(
  configurationSelector,
  (configuration) => configuration.get('useCoverPanels'),
);
